/**
 * Wihan Ui | main script
 * date: 2021/11/29
 * author: Tohid Zamani
 */

$(document).ready(function () {
    var categoriesElem = $('#categories');
    var searchSectionElem = $('.search-section');

    $('.categories-menu-icon').click(function () {
        categoriesElem.toggle();
    });

    $('.search-icon-section').click(function () {
        if (searchSectionElem.hasClass('search-section-show')) {
            $(this).children('#search-icon').addClass('fa-search').removeClass('fa-times');
            searchSectionElem.removeClass("search-section-show");
        } else {
            $(this).children('#search-icon').removeClass('fa-search').addClass('fa-times');
            searchSectionElem.addClass("search-section-show");
        }
    });

    if (window.innerWidth > 1080) {
        if (categoriesElem.children('li').length > 15) {
            if (categoriesElem.children('li').eq(15).html() !== "...") {
                categoriesElem.children('li').eq(14).after('<li class="categories-continues-show">...</li>', categoriesElem.children('li')[8].nextSibling);
                for (let p=0; p < 50; p++) {
                    categoriesElem.children('li').eq(16).appendTo(".categories-continues");
                }
            }
        }
    } else if (window.innerWidth > 767) {
        if (categoriesElem.children('li').length > 9) {
            if (categoriesElem.children('li').eq(9).html() !== "...") {
                categoriesElem.children('li').eq(8).after('<li class="categories-continues-show">...</li>', categoriesElem.children('li')[8].nextSibling);
                for (let p=0; p < 50; p++) {
                    categoriesElem.children('li').eq(10).appendTo(".categories-continues");
                }
            }
        }
    }

    $(window).on('resize', function(){
        if (window.innerWidth > 767) {
            categoriesElem.show();
        } else {
            categoriesElem.hide();
        }

        if (window.innerWidth > 1080) {
            if (categoriesElem.children('li').length > 15) {
                if (categoriesElem.children('li').eq(15).html() !== "...") {
                    categoriesElem.children('li').eq(14).after('<li class="categories-continues-show">...</li>', categoriesElem.children('li')[8].nextSibling);
                    for (let p=0; p < 50; p++) {
                        categoriesElem.children('li').eq(16).appendTo(".categories-continues");
                    }
                }
            }
        } else if (window.innerWidth > 767) {
            if (categoriesElem.children('li').length > 9) {
                if (categoriesElem.children('li').eq(9).html() !== "...") {
                    categoriesElem.children('li').eq(8).after('<li class="categories-continues-show">...</li>', categoriesElem.children('li')[8].nextSibling);
                    for (let p=0; p < 50; p++) {
                        categoriesElem.children('li').eq(10).appendTo(".categories-continues");
                    }
                }
            }
        }
    });

    $(document).on('click', '.categories-continues-show', function () {
        $('.categories-continues').toggle();
    });

    if ($('.editor-selected-news').length > 0) {
        var swiperEditorSelected = new Swiper(".swiperEditorSelected", {
            slidesPerView: 1,
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination",
            },
            grabCursor: true,
            effect: "creative",
            creativeEffect: {
                prev: {
                    shadow: true,
                    translate: ["-20%", 0, -1],
                },
                next: {
                    translate: ["100%", 0, 0],
                },
            },
        });
    }

    if ($('.swiperEditorSelectedCategory').length > 0) {
        var swiperEditorSelectedCategory = new Swiper(".swiperEditorSelectedCategory", {
            slidesPerView: 4,
            spaceBetween: 30,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
                480: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1080: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                }
            },
        });
    }

    $('#comments .meta .answer').click(function () {
        $(this).parent().parent().children('.answer-form').show();
    });
    $('#comments .answer-form .close-answer-form').click(function () {
        $(this).parent().hide();
    });

    if ($('.news-section').height() < 400 && window.outerHeight > 1000) {
        $('.news-section').css({"margin-bottom": "300px"});
    }

    if ($('.grid-container').children().length < 20 && window.outerHeight > 1000) {
        $('.grid-categories').css({"margin-bottom": "148px"});
    } else if ($('.grid-container').children().length < 20 && window.outerHeight > 900) {
        $('.grid-categories').css({"margin-bottom": "100px"});
    }
});

// latest news - marquee
function start() {
    new mq('latest-news');
    mqRotate(mqr);
}
window.onload = start;
